exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".small-toggle.react-toggle {\n  transform: scale(0.7);\n  transform-origin: 0% 50%;\n}\n\n.small-toggle.react-toggle .react-toggle-track {\n  height: 24px;\n  width: 50px;\n}\n\n.small-toggle.react-toggle .react-toggle-thumb {\n  height: 22px;\n  width: 22px;\n}\n\n.proctoring-subcontrol-section {\n  background: #f7f7f7;\n  border-radius: 4px;\n}\n\n.proctoring-subcontrol-tooltip {\n  z-index: 9999;\n  font-size: 12px;\n  margin-left: 4px;\n  padding: 5px 10px;\n}\n", ""]);

// exports
